import classnames from 'classnames'
import { Elements, HTMLSerializer } from 'prismic-reactjs'
import React, { ReactNode } from 'react'

import Image from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import Link from '~/components/Link'

import serializeImage from '~/data/serialize-image'
import serializeLink from '~/data/serialize-link'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export default function htmlSerializer(): HTMLSerializer<ReactNode | null> {
  return (type, element, content, _children) => {
    switch (type) {
      case Elements.hyperlink:
        const { href } = serializeLink(element?.data)
        return (
          <Link
            href={href}
            // theme="inherit"
            key={`rich-text-link-${href}`}
            // lineProps={{ initialLineState: 'none' }}
            children={content}
          />
        )
      case Elements.image:
        const image = serializeImage(element)

        return (
          <ImageWithPlaceHolder
            className={css.image}
            key={`rich-text-image-${image.src}`}
            layout="responsive"
            {...image}
          />
        )
      default:
        // Returning null will render the default PrismicRichText interpretation for the current type
        return null
    }
  }
}
